import ButtonPage from "./ButtonPage";
import Home from "./Home";

const Pages = {
    ButtonPage,
    Home,
};

export default Pages;
